import { Input, type InputProps } from '@components/ui/input';
import { Label } from '@components/ui/label';

import { cn } from '@/lib/utils';

type InputInnerLabelProps = {
  innerLabel: string;
  id: string;
  innerLabelClassName?: string;
  wrapperClassName?: string;
} & InputProps;
export const InputInnerLabel = ({
  innerLabel,
  innerLabelClassName,
  wrapperClassName,
  ...inputProps
}: InputInnerLabelProps) => (
  <div
    className={cn(
      'box-border flex h-8 overflow-hidden rounded-md border border-input border-solid ring-offset-background focus-within:outline-none focus-within:ring-2 focus-within:ring-ring',
      wrapperClassName
    )}
  >
    <Label
      className={cn(
        'flex h-full min-w-11 shrink-0 select-none items-center justify-start border-input border-r border-solid bg-gray-100 px-2 text-xs',
        innerLabelClassName
      )}
      htmlFor={inputProps.id}
    >
      {innerLabel}
    </Label>
    <Input
      {...inputProps}
      className={cn(
        'h-full grow border-none pr-0 focus-visible:outline-none focus-visible:ring-0',
        inputProps.className
      )}
      style={{
        textDecorationColor: 'hsl(var(--primary))',
        textUnderlineOffset: '2px'
      }}
    />
  </div>
);
